import React from 'react';
import {useSelector} from 'react-redux';

import {labels} from '../../../../../util/utils';

import CountDisplay from '../../../../Common/CountDisplay';
import StyledSelectedUsers from './StyledSelectedUsers';

const SelectedUsers = () => {
	const selectedContactsCount = useSelector(({contacts}) => contacts.selected.length);

	const props = {
		count: selectedContactsCount,
		label: labels.selectedLabel,
		singleLabel: labels.selectedLabel
	};

	return (
		<StyledSelectedUsers>
			<CountDisplay {...props} />
		</StyledSelectedUsers>
	);
};

export default SelectedUsers;
